import { render, staticRenderFns } from "./GHpolicy_b.vue?vue&type=template&id=18675318&"
import script from "./GHpolicy_b.vue?vue&type=script&lang=js&"
export * from "./GHpolicy_b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports